import HttpClient from './fetch_api';
import {GET_ORDER_PRESCRIPTION} from '../conf/appSetting';

export const GetPrescriptions = async (params, gatewayToken) =>
    HttpClient.get(HttpClient.concatNotNullParam(GET_ORDER_PRESCRIPTION.base, params), {
        Authorization: `Bearer ${gatewayToken}`
    });

export const GetPrescriptionPdf = async (id, gatewayToken) => {
    const response = await fetch(`${GET_ORDER_PRESCRIPTION.base}${id}/print`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${gatewayToken}`, Accept: 'application/pdf' },
    });
    if (!response.ok) throw new Error('Error al descargar la receta');
    return response.blob();
};
